import React from 'react';
import { Facebook, Instagram, Phone, Mail } from 'lucide-react';

export const Footer = ({ language }) => {
  const content = {
    en: {
      tagline: 'Your trusted neighborhood store',
      quickLinks: 'Quick Links',
      contact: 'Contact Info',
      followUs: 'Follow Us',
      rights: '© 2025 U-MART. All rights reserved.',
      links: ['Home', 'Products', 'Delivery', 'Contact']
    },
    gu: {
      tagline: 'તમારો વિશ્વાસુ પડોશી સ્ટોર',
      quickLinks: 'ઝડપી લિંક્સ',
      contact: 'સંપર્ક માહિતી',
      followUs: 'અમને ફોલો કરો',
      rights: '© 2025 યુ-માર્ટ. બધા અધિકારો અનામત.',
      links: ['હોમ', 'ઉત્પાદનો', 'ડિલિવરી', 'સંપર્ક']
    }
  };

  const t = content[language];

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_6d311a70-d8b2-4827-b078-6b13ef0b245b/artifacts/8obibit1_877d2277-d452-4124-a4ed-703d70df9d23.jpeg" 
                alt="U-MART" 
                className="h-12 w-12 object-contain bg-white rounded-lg p-1"
              />
              <span className="text-2xl font-bold text-red-500">U-MART</span>
            </div>
            <p className="text-gray-400">{t.tagline}</p>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">{t.quickLinks}</h3>
            <ul className="space-y-2">
              {t.links.map((link, index) => (
                <li key={index}>
                  <a href={`#${['home', 'products', 'delivery', 'contact'][index]}`} className="text-gray-400 hover:text-red-500 transition-colors">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">{t.contact}</h3>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4" />
                <a href="tel:+919924086184" className="hover:text-red-500 transition-colors">+91 99240 86184</a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4" />
                <a href="tel:+917096705611" className="hover:text-red-500 transition-colors">+91 70967 05611</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">{t.followUs}</h3>
            <div className="flex gap-4">
              <a href="#" className="bg-gray-800 hover:bg-red-600 p-3 rounded-full transition-colors duration-300">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="bg-gray-800 hover:bg-red-600 p-3 rounded-full transition-colors duration-300">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>{t.rights}</p>
        </div>
      </div>
    </footer>
  );
};